import React, { useEffect } from 'react';
import { FilterableMultiSelect } from 'carbon-components-react';
import { que8ValueProps } from '../../Maas360Estimator';
import { segmentsTracking } from 'src/common/lib/tracker';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';
import { convertToString } from 'src/apps/maas360-estimator/lib/utils';

type Step8Props = {
  que3Value: string;
  que4Value: string;
  que5Value: string;
  que6Value: string;
  que7Value: number;
  que8Value: que8ValueProps;
  setQue8Value: React.Dispatch<React.SetStateAction<que8ValueProps>>;
  setIsRequired: React.Dispatch<React.SetStateAction<boolean>>;
  checkboxState: unknown;
  useTranslation: TranslationFunction;
};

type eventProps = {
  target: {
    name: string;
    value: {
      selectedItems: {
        text: string;
        cookieText: string;
      }[];
    };
  };
};

const Step8 = ({
  que3Value,
  que4Value,
  que5Value,
  que6Value,
  que7Value,
  que8Value,
  setQue8Value,
  setIsRequired,
  checkboxState,
  useTranslation,
}: Step8Props) => {
  useEffect(() => {
    if (
      !checkboxState &&
      que4Value !== '' &&
      que5Value !== '' &&
      que6Value !== '' &&
      que7Value !== 0
    ) {
      setIsRequired(false);
    } else {
      setIsRequired(true);
    }
  }, [checkboxState]);

  const selectedItems = que8Value.multi.selectedItems;
  const osOptions = [
    {
      text: convertToString(useTranslation('que8_opt1', true)),
      cookieText: 'Windows',
    },
    {
      text: convertToString(useTranslation('que8_opt2', true)),
      cookieText: 'MacOS',
    },
    {
      text: convertToString(useTranslation('que8_opt3', true)),
      cookieText: 'ChromeOS',
    },
    {
      text: convertToString(useTranslation('que8_opt4', true)),
      cookieText: 'iOS',
    },
    {
      text: convertToString(useTranslation('que8_opt5', true)),
      cookieText: 'Android',
    },
    {
      text: convertToString(useTranslation('que8_opt6', true)),
      cookieText: 'iPadOS',
    },
    {
      text: convertToString(useTranslation('que8_opt7', true)),
      cookieText: 'Other',
    },
  ];

  const handleInputChange = (event: eventProps) => {
    setQue8Value({ ...que8Value, [event.target.name]: event.target.value });
  };

  return (
    <div>
      <label className="page_sub_heading padding_8">
        {useTranslation('que8_text_desc')}
      </label>
      <p>{useTranslation('que8_short_desc')}</p>
      <FilterableMultiSelect
        id="os"
        placeholder="Select OS"
        items={osOptions}
        itemToString={(item) => (item ? item.text : '')}
        initialSelectedItems={selectedItems.length > 0 ? selectedItems : []}
        onChange={(selectedItem) => {
          handleInputChange({
            target: {
              name: 'multi',
              value: selectedItem,
            },
          });
          segmentsTracking('CTA Clicked', {
            pageTitle: 'MaaS360 Plan Assessment',
            object: 'Mass360 page',
            resultValue: 'CTA clicked',
            CTA: `question 8 - ${selectedItem.selectedItems.length} OS - selected`,
            location: 'Assessment',
            action: '',
            field: '',
          });
        }}
      />
    </div>
  );
};

export default Step8;
